// extracted by mini-css-extract-plugin
export default {"tooltip":"LM-z","arrow":"MM-z"};